import React from "react";
import PropTypes from "prop-types";

import GradientOverflowContainer from "shared/components/GradientOverflowContainer";

import "./Essay.scss";

const Essay = (props) => (
	<GradientOverflowContainer className="profile-comment-essay-widget">
		<h3 className="profile-comment-essay-widget-title">{props.essay_title}</h3>
		<p className="profile-comment-essay-widget-text" dangerouslySetInnerHTML={{ __html: props.essay_content }} />
		{props.photo_url && (
			<img className="profile-comment-essay-widget-image" alt="user pic" src={props.photo_url} />
		)}
	</GradientOverflowContainer>
);

Essay.propTypes = {
	essay_title: PropTypes.string.isRequired,
	essay_content: PropTypes.string.isRequired,
	photo_url: PropTypes.string,
};

Essay.defaultProps = {
	photo_url: null,
};

export default Essay;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileComment/Essay.jsx